import { ReusableModal } from '../../components/ReusableModal';
import {
    useCheckoutElements,
    PaymentElement,
    BillingAddressElement
} from '@stripe/react-stripe-js/checkout';
import { useEffect } from 'react';

// interface CheckoutFormProps {
//     // onLoad?: (f: any) => {};

// }

const CheckoutForm = ({ handleClose, show }) => {
    const checkoutState = useCheckoutElements();

    // useImperativeHandle(ref, async () => ({
    async function submitForm() {
        if (checkoutState.type === 'loading') {
            return <div>Loading...</div>;
        } else if (checkoutState.type === 'error') {
            return <div>Error: {checkoutState.error.message}</div>;
        }

        const { checkout } = checkoutState;
        const result = await checkout.confirm();

        if (result.type === 'error') {
            // Show error to your customer (for example, payment details incomplete)
            console.log(result.error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }
    }
    // }));

    // useEffect(() => {
    //     if (onLoad) {
    //         onLoad(submitForm);
    //     }
    // }, [onLoad]);

    const actions = [
        {
            label: 'Cancel',
            callback: handleClose,
            active: true
        },
        {
            label: 'Submit',
            callback: submitForm,
            active: true
        }
    ];

    return (
        <ReusableModal title="Checkout" actions={actions} show={show} handleClose={handleClose}>
            <form>
                <PaymentElement />
                <hr />
                <BillingAddressElement />
            </form>
        </ReusableModal>
    );
};

export default CheckoutForm;
